import { BaseViewStore } from 'core/stores';
import { action, observable } from "mobx";

class FacilityOrderTemplateItemNewFlowDeleteQuestionModalStore extends BaseViewStore {
    @observable accessor disabled = false;
    @observable accessor loadTemplate = false;
    @observable accessor loadTemplateItem = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.deleteItem = this.modalParams.data.deleteItem;
        this.deletePatient = this.modalParams.data.deletePatient;
        this.isNikoHealthModal = this.modalParams.data.isNikoHealthModal;
    }

    @action.bound
    async deleteFacilityOrdeTemplateItem(deletePatient) {
        try {
            this.disabled = true;
            if (deletePatient) {
                this.loadTemplate = true;
                await this.deletePatient();
            }
            else {
                this.loadTemplateItem = true;
                await this.deleteItem();
            }
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
    }

}

export default FacilityOrderTemplateItemNewFlowDeleteQuestionModalStore;
